export default "__VITE_ASSET__7523f792__"